<vc-form
    #userDetailsForm
    ariaLabeledBy="Details"
    [primaryLabel]="'COMMON_UI.SAVE' | transloco"
    [secondaryLabel]="'COMMON_UI.CANCEL' | transloco"
    [showButtons]="showButtons && !readonly"
    [showPrimaryButton]="showPrimaryButton"
    [clearFieldsOnSecondary]="false"
    [showSecondaryButton]="showSecondaryButton"
    (primaryTrigger)="validateAndSubmit($event)"
    (secondaryTrigger)="resetDetails()">
    <div class="vc-user-details-form-wrapper">
        <vc-input
            class="space-bottom-8"
            [label]="'COMMON_UI.USERNAME' | transloco"
            [requiredText]="'COMMON_UI.VALIDATION.FIELD_IS_REQUIRED' | transloco"
            [required]="!readonly"
            [readonly]="readonly || readonlyUsername"
            [maxLength]="255"
            [(value)]="username"
            (valueChange)="user.userKey.username = $event"></vc-input>
        @if (showPassword) {
            <vc-password
                class="space-bottom-8"
                [label]="'COMMON_UI.INPUT.PASSWORD' | transloco"
                [description]="'LOGIN.PASSWORD_REQUIREMENTS_TEXT' | transloco"
                [requiredText]="'COMMON_UI.VALIDATION.FIELD_IS_REQUIRED' | transloco"
                [required]="passwordRequired"
                [autocomplete]="'new-password'"
                [(value)]="password"
                [maxLength]="32"
                [minLength]="8"
                [minNumbers]="1"
                [minUpper]="1"
                [minSpecial]="1"
                [minLower]="1"
                [showVisibleButton]="true"
                [showClear]="true"
                (valueChange)="user.password = $event"></vc-password>
        }
        <vc-input
            class="space-bottom-8"
            [label]="'COMMON_UI.EMAIL' | transloco"
            [requiredText]="'COMMON_UI.VALIDATION.FIELD_IS_REQUIRED' | transloco"
            [readonly]="readonly"
            [maxLength]="255"
            [required]="true"
            [requiredText]="'COMMON_UI.VALIDATION.FIELD_IS_REQUIRED' | transloco"
            [validationFunction]="validateEmail"
            [(value)]="email"
            (valueChange)="user.email = $event"></vc-input>
        @if (showOrg) {
            <vc-autocomplete
                class="space-bottom-8"
                [label]="'COMMON_UI.ORGANIZATION' | transloco"
                [placeholder]="'COMMON_UI.SEARCH_FOR_ORGANIZATION' | transloco"
                [requiredText]="'COMMON_UI.VALIDATION.FIELD_IS_REQUIRED' | transloco"
                [readonly]="readonly || readonlyOrg"
                [(value)]="org"
                [options]="orgs"
                [required]="orgRequired"
                [showClear]="true"
                [suffixIcon]="readonlyOrg ? '' : 'search'"
                [itemRenderer]="orgRenderer"
                (valueChange)="updateOrg($event)"
                (filterChange)="filterChange.emit($event)"></vc-autocomplete>
        }
        <vc-input
            class="space-bottom-8"
            [label]="'CORE.INPUT.FIRSTNAME' | transloco"
            [readonly]="readonly"
            [required]="firstNameRequired"
            [maxLength]="255"
            [requiredText]="'COMMON_UI.VALIDATION.FIELD_IS_REQUIRED' | transloco"
            [(value)]="firstName"
            (valueChange)="user.firstName = $event"></vc-input>
        <vc-input
            class="space-bottom-8"
            [label]="'CORE.INPUT.LASTNAME' | transloco"
            [readonly]="readonly"
            [required]="lastNameRequired"
            [maxLength]="255"
            [requiredText]="'COMMON_UI.VALIDATION.FIELD_IS_REQUIRED' | transloco"
            [(value)]="lastName"
            (valueChange)="user.lastName = $event"></vc-input>
        @if (showLanguageSelector) {
            <vc-select
                class="space-bottom-8"
                [label]="'CORE.INPUT.DEFAULT_LANGUAGE' | transloco"
                [options]="languages"
                [(value)]="language"
                [prefixTemplate]="languagePrefixTemplate"
                [optionTemplate]="languageTemplate"
                (valueChange)="updateLanguage($event)"></vc-select>
        }
        <vc-phone
            class="space-bottom-8"
            [numberLabel]="'COMMON_UI.PHONE_NUMBER' | transloco"
            [codeLabel]="'CORE.INPUT.COUNTRY' | transloco"
            [extLabel]="'CORE.INPUT.EXTENSION' | transloco"
            [readonly]="readonly"
            [numberValidationFunction]="phoneNumberValidator"
            [extValidationFunction]="phoneExtensionValidator"
            [maxNumberLength]="40"
            [(value)]="primaryPhone"
            [showExt]="true"
            (valueChange)="updatePrimaryPhone($event)"></vc-phone>
        <ng-content select="[userDetailsActions]"></ng-content>
        @if (showNotes) {
            <vc-textarea
                [label]="'COMMON_UI.NOTES' | transloco"
                [rows]="3"
                [readonly]="readonly"
                [(value)]="notes"
                (valueChange)="user.notes = $event"></vc-textarea>
        }
    </div>
</vc-form>
<ng-template #languageTemplate let-option>
    <vc-country-flag [country]="option === 'en' ? 'us' : option"></vc-country-flag>
    <span>{{ getLanguageLabel(option) }} </span>
</ng-template>
<ng-template #languagePrefixTemplate let-value>
    <vc-country-flag [country]="value === 'en' ? 'us' : value"></vc-country-flag>
</ng-template>
